//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    ie_objectfit_fallback,
    ie_objectfit_fallback_container
} from "../regular/fallbacks.js";

export default {
    props: {
        article: {},
        external: {
            default: false
        },
        big_post: {
            default: false
        }
    },
    mounted: function() {
        ie_objectfit_fallback_container(this.$refs.article_teaser_image);
    },
    computed: {
        person_phone: function() {
            return this.article.acf_data ?
                this.article.acf_data.mobile_phone_number :
                "";
        },
        person_email: function() {
            return this.article.acf_data ? this.article.acf_data.email : "";
        },
        person_excerpt_data: function() {
            if (this.article.post_type.name != "person") {
                return false;
            }

            return this.article.excerpt;
        },
        event_date: function () {
            if (this.article.post_type.name != "event") {
                return false;
            }

            if(this.article.acf_data.event_date_start) {
                return this.article.acf_data ?
                    this.article.acf_data.event_date_start.split(" ")[0] :
                    "";
            }

            return "";
        },
        is_release: function() {
            if (this.article.post_type.name == "release") return true;
            return false;
        },
        first_release_term : function () {
            return this.get_first_term_of_taxonomy('release_type');
        }
    },
    methods: {
        is_person: function() {
            return this.article.post_type.name == "person";
        },
        is_event: function() {
            return this.article.post_type.name == "event";
        },
        get_first_term_of_taxonomy : function (taxonomy) {
            let selected_term = false
            for(let t in this.article.terms) {
                let term = this.article.terms[t];

                if(term.taxonomy == taxonomy) {
                    if(term.primary) {
                        return term
                    } else if(selected_term === false) {
                        selected_term = term
                    }
                }
            }

            return selected_term;
        },
          relocate() {
            window.location.href = this.article.permalink;
        }

    },
    data: function() {
        return {
            translations : rest_options.options.translations
        };
    },
    filters: {
        parse_time: function(value) {
            if (!value) return "";

            // Handle case of weird slideshare timestamps
            let targetTime = new Date();
            let offset = targetTime.getTimezoneOffset();
            value = value.replace(" UTC", "");

            // And specifically iOS weirdness
            value = value.replace(/-/g, "/");
            value = new Date(Date.parse(value));
            value.setTime(value.getTime() - offset);
            return value.toLocaleString("fi-FI", {
                day: "numeric",
                month: "numeric",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            });
        },
        parse_youtube: function(value) {
            value = value.replace(/T/g, " ");
            value = value.replace(/.000Z/g, " UTC");
            return value;
        }
    }
};



// WEBPACK FOOTER //
// ./js/vue/article-teaser.vue